import { styled } from 'styled-components';

export const Wrapper = styled.div`
  padding: 64px 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 24px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 12px;

  > h2 {
    justify-self: flex-start;
  }

  > button {
    justify-self: flex-end;
    height: fit-content;
  }
`;

export const Cards = styled.div`
  display: grid;
  flex-wrap: wrap;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  width: 100%;
  height: 100%;

  ${({ theme }) => theme.breakpoints.md.query} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    grid-template-columns: repeat(1, 1fr);
  }
`;
